import * as settings from '../globals/settings';
import is from 'is_js'
import queryString from 'query-string';
import { createError, createUnvalidatedAccountError } from '../util/error_v3';

// Config!
// FIXME This is a secret and it should not be stored in config.
const apiToken = settings.API_TOKEN;

const baseUrl = settings.API_URL;

const apiTokenHeader = 'X-VSF-API-Token';
const AuthorizationHeader = 'Authorization';

export const ACCESS_DENIED_ERROR_CODE = 'ADE';
export const AUTHENTICATION_REQUIRED_ERROR_CODE = 'ARE';
export const SERVICE_INTERRUPTION_ERROR_CODE = 'SIE';
export const MISSING_IDENTIFIER_ERROR_CODE = 'MIE';
export const NO_SOURCE_ID_ERROR_CODE = 'LREE';
export const DATA_ACCESS_ERROR_CODE = 'DAE';
export const LOGIN_FAILED_ERROR_CODE = 'IUE';
export const UNKNOWN_ERROR_CODE = 'UE';
export const INVALID_ITEM_EXCEPTION_CODE = 'IIE';
export const INVALID_PASSWORD_EXCEPTION_CODE = 'IPE';
export const CREATE_USER_EXCEPTION_CODE = 'CUE';
export const ACCOUNT_LOCKED_ERROR_CODE = 'ALO';
export const USER_NOT_FOUND_EXCEPTION_CODE = 'UNF';
export const METHOD_NOT_SUPPORTED_EXCEPTION_CODE = 'MNSE';
export const USERNAME_EXISTS_EXCEPTION_CODE = 'UNAE';
export const UNVALIDATED_ACCOUNT_ERROR = 'UVA';
export const PATIENT_VALIDATION_ERROR = 'PVE';

function timeout(ms, promise) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(new Error("Network connection timeout"))
        }, ms)
        promise.then(resolve, reject)
    })
}

export function getDemographics(language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/client/';
    return fetch(encodeURI(finalUrl), data);
}

export function getTestResults(language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/results/';
    return fetch(encodeURI(finalUrl), data);
}

export function getImmunizationResults(language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/immunization/';
    return fetch(encodeURI(finalUrl), data);
}

export function getResultsPdf(language, deviceId, authorizationToken, resultId) {
    let headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    }
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    let headers = new Headers(headerData);
    let data = { method: 'GET', headers: headers };
    let finalUrl = settings.API_URL + 'v1/pdf/result?result_id=' + resultId;
    return fetch(encodeURI(finalUrl), data);
}

export function authenticate(username, password, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    var headers = new Headers(headerData);
    var bodyData = {
        userName: username,
        password: password,
    };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/authentication/login/';
    return fetch(encodeURI(finalUrl), data);
}

export function register(dto, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    var headers = new Headers(headerData);
    var bodyData = { registerDto: dto };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/authentication/register/';
    return fetch(encodeURI(finalUrl), data);
}

export function logOut(language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'DELETE', headers: headers }
    let finalUrl = baseUrl + 'v1/authentication/logout/';
    //return fetch(encodeURI(finalUrl), data).then((response) => response.json());
    return fetch(encodeURI(finalUrl), data);
}

export function passwordChange(oldPassword, newPassword, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var bodyData = { 'oldPassword': oldPassword, 'newPassword': newPassword };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + '/v1/authentication/change_password';
    return fetch(encodeURI(finalUrl), data);
}

export function forgotPassword(username, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var bodyData = { userName: username };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/authentication/forgot_password';
    return fetch(encodeURI(finalUrl), data);
}

export function resetPassword(newPassword, confirmNewPassword, token, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    // headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var bodyData = { newPassword: newPassword, confirmNewPassword: confirmNewPassword };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let url = "v1/authentication/reset_password?";
    Object.keys(token).forEach(key => url = url + queryString.stringify(token));
    let finalUrl = baseUrl + url;
    return fetch(encodeURI(finalUrl), data);
}

export function doEmailConfirmation(token, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    let headers = new Headers(headerData);
    let data = { method: 'GET', headers: headers };
    let url = "v1/authentication/email_validation?";
    Object.keys(token).forEach(key => url = url + queryString.stringify(token));
    let finalUrl = baseUrl + url;
    return fetch(encodeURI(finalUrl), data);
}

export function requestUsername(emailAddress, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    var headers = new Headers(headerData);
    var bodyData = { 'email': emailAddress };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/authentication/forgot_username/';
    return fetch(encodeURI(finalUrl), data);
}

// FIXME This is hardcoded, should probably not be hard coded
function makeVersion() {
    let deviceType;
    if (is.desktop()) {
        deviceType = 'Desktop';
    } else if (is.mobile()) {
        deviceType = 'Mobile';
    } else {
        deviceType = 'Tablet';
    }
    return settings.VSF_CLIENT_NAME + '-' + settings.VERSION + '-' + deviceType;
}

// FIXME Internet explorer apparently does not support response.status!
export function handleLoginErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };
    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 201 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE) {
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 403 && json.error.exception === ACCOUNT_LOCKED_ERROR_CODE) {
        error = createError(ACCOUNT_LOCKED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 403 && json.error.exception === UNVALIDATED_ACCOUNT_ERROR) {
        error = createUnvalidatedAccountError(UNVALIDATED_ACCOUNT_ERROR, statusCode, errorId, json.error.code);
    } else if (statusCode === 401 && json.error.exception === LOGIN_FAILED_ERROR_CODE) {
        error = createError(LOGIN_FAILED_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

// FIXME What are the error codes here?
export function handleLogoutErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

// FIXME What are the error codes here?
export function handleRegisterErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_PASSWORD_EXCEPTION_CODE) {
        error = createError(INVALID_PASSWORD_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === USERNAME_EXISTS_EXCEPTION_CODE) {
        error = createError(USERNAME_EXISTS_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === CREATE_USER_EXCEPTION_CODE) {
        error = createError(CREATE_USER_EXCEPTION_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handlePasswordChangeErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_PASSWORD_EXCEPTION_CODE) {
        error = createError(INVALID_PASSWORD_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleRequestUsernameErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }
    console.log(statusCode, json.error.exception);
    if (statusCode === 201 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_PASSWORD_EXCEPTION_CODE) {
        error = createError(INVALID_PASSWORD_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleForgotPasswordErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 || statusCode === 201 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_PASSWORD_EXCEPTION_CODE) {
        error = createError(INVALID_PASSWORD_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === USER_NOT_FOUND_EXCEPTION_CODE) {
        error = createError(USER_NOT_FOUND_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === USERNAME_EXISTS_EXCEPTION_CODE) {
        error = createError(USERNAME_EXISTS_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 403 && json.error.exception === UNVALIDATED_ACCOUNT_ERROR) {
        error = createUnvalidatedAccountError(UNVALIDATED_ACCOUNT_ERROR, statusCode, errorId, json.error.code);
    } else if (statusCode === 403 && json.error.exception === ACCOUNT_LOCKED_ERROR_CODE) {
        error = createError(ACCOUNT_LOCKED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 503 && json.error.exception === SERVICE_INTERRUPTION_ERROR_CODE) {
        error = createError(SERVICE_INTERRUPTION_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE) {
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleResetPasswordErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 || statusCode === 201 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_PASSWORD_EXCEPTION_CODE) {
        error = createError(INVALID_PASSWORD_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === USER_NOT_FOUND_EXCEPTION_CODE) {
        error = createError(USER_NOT_FOUND_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === METHOD_NOT_SUPPORTED_EXCEPTION_CODE) {
        error = createError(METHOD_NOT_SUPPORTED_EXCEPTION_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleVerifyEmailErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === USER_NOT_FOUND_EXCEPTION_CODE) {
        error = createError(USER_NOT_FOUND_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 400 && json.error.exception === CREATE_USER_EXCEPTION_CODE) {
        error = createError(CREATE_USER_EXCEPTION_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

// FIXME What are the error codes here?
export function handleGetTestResultsErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === MISSING_IDENTIFIER_ERROR_CODE) {
        error = createError(MISSING_IDENTIFIER_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_SOURCE_ID_ERROR_CODE) {
        error = createError(NO_SOURCE_ID_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === PATIENT_VALIDATION_ERROR) {
        error = createError(PATIENT_VALIDATION_ERROR, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE) {
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 503 && json.error.exception === SERVICE_INTERRUPTION_ERROR_CODE) {
        error = createError(SERVICE_INTERRUPTION_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

/*function checkStatus() {
    let lang = resolveLang();
    let vers = getVersionString();
    let deviceId = getDeviceId();
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": lang,
        "X-VSF-Client-Version": vers,
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[mylabsApiTokenHeader] = mylabsApiToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = mylabsUrl + 'status/';
    return timeout(settings.STATUS_TIMEOUT, fetch(encodeURI(finalUrl), data).then((response) => response.json()));
}*/

// FIXME What to do if service becomes unavailable?
// At the moment, don't handle this here.

/* What was this for???
function determineLogoutStatus(response) {
    if (response.success == true) {
        return true;
    } else if (response.success == false) {
        if (response.errorCode == ACCESS_DENIED_ERROR_CODE) {
            return true;
        } else {
            return false;
        }
    }
}*/


function parseAuthorization(str) {
    return str.substring(7);
}

export function getAuthorizationToken(response) {
    let headers = response.headers;
    if (headers.get(AuthorizationHeader) != null) {
        return parseAuthorization(headers.get(AuthorizationHeader));
    }
    return null;
}

/*module.exports = {
getLab: getLab,
//ACCESS_DENIED_ERROR_CODE: ACCESS_DENIED_ERROR_CODE,
//SERVICE_INTERRUPTION_ERROR_CODE: SERVICE_INTERRUPTION_ERROR_CODE,
//MISSING_IDENTIFIER_ERROR_CODE: MISSING_IDENTIFIER_ERROR_CODE,
authenticate: authenticate,
logOut: logOut,
determineLogoutStatus: determineLogoutStatus,
getAuthorizationToken: getAuthorizationToken,
//checkStatus: checkStatus,
}*/
